<template>
    <div>
        <a-form-model ref="emailTemplateForm" :model="form" :rules="rules" v-bind="layout">
            <a-form-model-item
                    ref="name"
                    label="模板名称"
                    prop="name"
                    :extra="formErr.name"
                    :validateStatus='!formErr.name||formErr.name==""?"":"error"'
            >
                <a-input
                        :maxLength = 100
                        v-model="form.name"
                        @change="(e) => { formErr.name=''}"
                        @blur="(e) => {  form.name = e.target.value.trim() }"
                />
            </a-form-model-item>

            <a-form-model-item ref="theme" label="主题" prop="theme" :extra="formErr.theme" :validateStatus='!formErr.theme || formErr.theme == "" ? "" : "error"'>
                <a-input type="textarea" :maxLength = 200 v-model="form.theme" @change="(e) => {formErr.theme}" @blur="(e) => {form.theme = e.target.value.trim()}">
                </a-input>
            </a-form-model-item>

            <a-form-model-item
                    ref="content"
                    label="内容"
                    prop="content"
                    :help="formErr.content"
                    :validateStatus='!formErr.content||formErr.content==""?"":"error"'
            >
                <a-input v-model="form.content"  type="hidden" />
                <ckeditor4 ref="ckeditor" :parameter="1" :value="contenta" v-on:input="ckeditorContent" @instanceReadyCk="instanceReadyCk"></ckeditor4>
            </a-form-model-item>

            <a-form-model-item ref="thumb" label="封面图" prop="thumb" :help="formErr.thumb">
                <Myupload :url="form.thumb||''"  @fileList="setFileList"/>
            </a-form-model-item>

            <a-form-model-item
                    ref="status"
                    label="显示状态"
                    prop="status"
                    :extra="formErr.status"
                    :validateStatus='!formErr.status||formErr.status==""?"":"error"'
            >
                <a-radio-group v-model="form.status"  >
                    <a-radio :value="1"> 发布 </a-radio>
                    <a-radio :value="0"> 草稿 </a-radio>
                </a-radio-group>
            </a-form-model-item>
        </a-form-model>

        <div style="text-align:center">
            <a-button :style="{ marginRight: '8px' }" type="primary" @click="onSubmit">
                确定
            </a-button>
            <a-button  @click="onCancel">
                取消
            </a-button>
        </div>
    </div>
</template>
<script>
import ckeditor4 from '../../Components/ckeditors';
import {submitForm} from "../../../utils/utils";
import Myupload from '../../Components/my-upload/index.vue'
import API from "../api";

export default {
    components:{ckeditor4,Myupload},
    data() {
        return {
            contenta: "",
            id: this.$route.query.id,
            form: {
                name: "",
                theme: "",
                content: "",
                status: 1,
                thumb:""
            },
            formErr: {
                name: "",
                theme: "",
                content: "",
            },
            rules: {
                name: [{required: true, message: "请输入模板名称 ", trigger: "blur"}, {  whitespace: true, message: "请输入模板名称 " }],
                content: [{required: true, message: "请输入内容 ", trigger: "blur"}, {  whitespace: true, message: "请输入内容 " }],
            },
            layout: {
                labelCol: { span: 3 },
                wrapperCol: { span: 18 },
            },
        };
    },
    methods: {
        ckeditorContent(val) {
            this.form.content = val
        },
        instanceReadyCk(type){
            if(type==true){
                let _that=this
                this.$nextTick().then(function () {
                    if(_that.id!=undefined){ _that.editform(_that.id)}
                })
            }

        },

        // 提交表单
        onSubmit() {
            let _this = this;
            this.$refs.ckeditor.$emit("getText")
            this.$refs.emailTemplateForm.validate(valid => {
                let url
                if (valid) {
                    this.form.id == '' || this.form.id == undefined ? url = API.emailTemplate.SUBMIT_ADD : url = API.emailTemplate.SUBMIT_EDIT
                    submitForm(url, _this.form).then(res => {
                        if (res == true) {
                            this.$router.push({ path: "/EmailTemplate/EmailTemplateList" });
                        } else {
                            res.map((item) => {
                                this.formErr[item.field] = item.msg
                            })
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        // 取消按钮
        onCancel() {
            this.$router.push({ path: "/EmailTemplate/EmailTemplateList" });
        },

        // 获取 编辑数据
        editform(){
            API.emailTemplate.EDIT_DATA({id: this.id}).then(res => {
                let data=res.data.data.info
                this.form = data
                let _that=this
                this.$nextTick().then(function () {
                        // setTimeout(() => {
                            _that.contenta = data.content
                        // }, 300)
                })
                // this.$nextTick(() => {
                //     setTimeout(() => {
                //         this.contenta = data.content
                //     }, 80)
                // })
                this.form.id=this.id
            })
        },
        setFileList(url){
            this.form.thumb = url
        }
    },
    created() {
        this.$store.state.adminleftnavnum = "/EmailTemplate/EmailTemplateList"; //设置左侧导航2-2 active
    },
    mounted(){
        let _that=this
        // this.$nextTick().then(function () {
        //     if(_that.id!=undefined){ _that.editform(_that.id)}
        // })
        // if(this.id!=undefined){
        //     this.editform( )
        // }
    },
}
</script>
